// eslint-disable-next-line
import CircularIndeterminate from "./Loading"
// eslint-disable-next-line
import { Button, Stack, TextField } from "@mui/material";
import { Box } from "@mui/system";
// eslint-disable-next-line
import axios from "axios";
// eslint-disable-next-line
import { useSnackbar } from "notistack";
// eslint-disable-next-line
import React, { useState } from "react";
// eslint-disable-next-line
import { useHistory, Link } from "react-router-dom";
// eslint-disable-next-line
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Login.css";

const Login = () => {
  // eslint-disable-next-line
  const { enqueueSnackbar } = useSnackbar();

  // TODO: CRIO_TASK_MODULE_LOGIN - Fetch the API response
  const [data,updateData] = useState({
    username:"",
    password :"",
    
    
  })
  const [isLoading,setLoad]= useState(false)

  const handlingInput = (e)=>{
    const name = e.target.name;
    const value = e.target.value
    updateData({...data, [name]:value})
  }
  const history = useHistory();
  /**
   * Perform the Login API call
   * @param {{ username: string, password: string }} formData
   *  Object with values of username, password and confirm password user entered to register
   *
   * API endpoint - "POST /auth/login"
   *
   * Example for successful response from backend:
   * HTTP 201
   * {
   *      "success": true,
   *      "token": "testtoken",
   *      "username": "criodo",
   *      "balance": 5000
   * }
   *
   * Example for failed response from backend:
   * HTTP 400
   * {
   *      "success": false,
   *      "message": "Password is incorrect"
   * }
   *
   */
  // eslint-disable-next-line
  const login = async (formData) => {

    if(validateInput(formData)){

    try {
      delete formData.confirmPassword
      setLoad(true);
      // eslint-disable-next-line
      const res =await axios.post(`${config.endpoint}/auth/login`, JSON.stringify(formData), {
        headers: { "Content-Type": "application/json" },
      });
      const { token, username, balance } = res.data;
        console.log(res.data);
      setLoad(false);
      enqueueSnackbar('Logged in successfully', { variant: "success" });
      persistLogin(token, username, balance);
      history.push("/", { from: "Login" });
      
      
    } catch (e) {
     // console.log(e + "hello")
      setLoad(false);
      if (e.response && e.response.status >= 400 ){
        enqueueSnackbar(e.response.data.message, { variant: "error" });
      }
      else{
        enqueueSnackbar('Something went wrong. Check that the backend is running, reachable and returns valid JSON.', { variant: "error" });
      }
    }
      
      
    }
  };

  // TODO: CRIO_TASK_MODULE_LOGIN - Validate the input
  /**
   * Validate the input values so that any bad or illegal values are not passed to the backend.
   *
   * @param {{ username: string, password: string }} data
   *  Object with values of username, password and confirm password user entered to register
   *
   * @returns {boolean}
   *    Whether validation has passed or not
   *
   * Return false and show warning message if any validation condition fails, otherwise return true.
   * (NOTE: The error messages to be shown for each of these cases, are given with them)
   * -    Check that username field is not an empty value - "Username is a required field"
   * -    Check that password field is not an empty value - "Password is a required field"
   */
  // eslint-disable-next-line
  const validateInput = (data) => {
    const name = data.username;
    const Pass = data.password;
    
    if (!name){
      enqueueSnackbar('Username is a required field.', { variant: "warning" }); 
    return false;
    }
    else if(name.split("").length<6){
      enqueueSnackbar('Username must be at least 6 characters', { variant: "warning" }); 
    return false;
    }
    else if(!Pass){
      enqueueSnackbar('Password is a required field.', { variant: "warning" }); 
    return false;
    }
    else if(Pass.split("").length<6){
      enqueueSnackbar('Password must be at least 6 characters', { variant: "warning" }); 
    return false;
    }
    else{
      return true;
    }
  };

  // TODO: CRIO_TASK_MODULE_LOGIN - Persist user's login information
  /**
   * Store the login information so that it can be used to identify the user in subsequent API calls
   *
   * @param {string} token
   *    API token used for authentication of requests after logging in
   * @param {string} username
   *    Username of the logged in user
   * @param {string} balance
   *    Wallet balance amount of the logged in user
   *
   * Make use of localStorage: https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage
   * -    `token` field in localStorage can be used to store the Oauth token
   * -    `username` field in localStorage can be used to store the username that the user is logged in as
   * -    `balance` field in localStorage can be used to store the balance amount in the user's wallet
   */
  // eslint-disable-next-line
  const persistLogin = (token, username, balance) => {
    localStorage.setItem("token", token);
    localStorage.setItem("username", username);
    localStorage.setItem("balance", balance);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="100vh"
    >
      <Header hasHiddenAuthButtons={false} />
      <Box className="content">
        <Stack spacing={2} className="form">
        <h2 className="title">Login</h2>
          <TextField
            id="username"
            label="username"
            variant="outlined"
            title="Username"
            name="username"
            placeholder="Enter Username"
            fullWidth
           value={data.username}
            onChange={(e)=>handlingInput(e)}
          />
          <TextField
            id="password"
            variant="outlined"
            label="password"
            name="password"
            type="password"
            helperText="Password must be atleast 6 characters length"
            fullWidth
            placeholder="Enter a password with minimum 6 characters"
           value={data.password}
            onChange={(e)=>handlingInput(e)}
          />
          { !isLoading ?
           <Button className="button" variant="contained" onClick={()=>login(data)}>
            Login to QKart
           </Button>
           
           : <p className="loading"><CircularIndeterminate /></p>
            }

           <p className="secondary-action">
           Don’t have an account? {" "}
            
             
           <Link className="link" to="/register">
            Register now
            </Link>
             </p>
           
        </Stack>
      </Box>
      <Footer />
    </Box>
  );
};

export default Login;
